<template>
  <div class="mt-2 d-block d-sm-flex bg-light justify-content-between p-2 rounded border">
    <div class="d-inline-block">
      <span class="SPOEBD mr-2"><b-icon icon="bell" ></b-icon></span>
      <span>Oferta Speciala</span>
    </div>
    <div class="d-inline-block">
      <span class="SPOEBD mr-2"><b-icon icon="clock-history" ></b-icon></span>
      <span>Early Booking</span>
    </div>
    <div class="d-inline-block">
      <span class="SPOEBD mr-2"><b-icon icon="flag" ></b-icon></span>
      <span>Last Minute</span>
    </div>
    <div class="d-inline-block">
      <span class="FCAVL mr-2"><b-icon icon="person-plus" ></b-icon></span>
      <span>Copil Gratuit</span>
    </div>
    <div class="d-inline-block">
      <span class="FCAVL mr-2"><b-icon icon="check-circle" ></b-icon></span>
      <span>Disponibil</span>
    </div>
    <div class="d-inline-block">
      <span class="RQNA mr-2"><b-icon icon="chat-quote" ></b-icon></span>
      <span>La Cerere</span>
    </div>
    <div class="d-inline-block">
      <span class="RQNA mr-2"><b-icon icon="slash-circle" ></b-icon></span>
      <span>Indisponibil</span>
    </div>
    <div class="d-inline-block">
      <span class="text-danger mr-2"><b-icon icon="exclamation-octagon" ></b-icon></span>
      <span>Atentie</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Legend'
}
</script>
